// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/config.css'
import './assets/css/main.css'
import './assets/css/custom.css'
import VCalendar from 'v-calendar'
import VueTablerIcons from 'vue-tabler-icons'
import i18n from './i18n'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import PhosphorIcons from 'phosphor-icons'
import * as VueGoogleMaps from "vue2-google-maps" // Import package
import GmapCluster from 'vue2-google-maps/dist/components/cluster' // nécessite installation de marker-clusterer-plus avec npm: "npm i @googlemaps/markerclustererplus"
import VueSocialSharing from 'vue-social-sharing'

import * as Sentry from '@sentry/vue'
import {Integrations} from '@sentry/tracing'

import setupInterceptors from './services/setupInterceptors'
import TokenService from "./services/tokenService";
import VueMeta from 'vue-meta';

Vue.config.productionTip = false

// Make BootstrapVue available throughout project
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(PhosphorIcons)
Vue.use(VueSocialSharing);
Vue.use(VueMeta);

// Lib utlisée pour les icones
// Version 1.* (compatible avec Vue 2)
// Icones : https://tabler-icons.io/
// Documentation lib : https://github.com/alex-oleshkevich/vue-tabler-icons
Vue.use(VueTablerIcons)

// google maps clusters
// documentation: https://xkjyeah.github.io/vue-google-maps/autoapi.html
Vue.component('GmapCluster', GmapCluster)

setupInterceptors(store, router)

VuePhoneNumberInput.props.translations.default = function () {
  return {
    countrySelectorLabel: 'Code pays',
    countrySelectorError: 'Choisir un pays',
    phoneNumberLabel: 'Numéro de téléphone',
    example: 'Exemple :'
  }
}
VuePhoneNumberInput.props.color.default = '#80BDFF'
VuePhoneNumberInput.props.validColor.default = '#99CC55'
VuePhoneNumberInput.props.errorColor.default = '#FF6464'
VuePhoneNumberInput.props.defaultCountryCode.default = 'FR'
VuePhoneNumberInput.props.onlyCountries.default = function () {
  return [
    'FR', // France
    'RE', // Réunion
    'MQ', // Martinique
    'GF', // Guyane française
    'YT', // Mayotte
    'GP', // Guadeloupe
  ]
}
Vue.component('vue-phone-number-input', VuePhoneNumberInput)

Vue.use(VCalendar, {
  componentPrefix: 'vc' // Use <vc-calendar /> instead of <v-calendar />
})

const googleMapsKey_PROD = "AIzaSyCTpJigaGmB0PVJdPw99kxoNSCXQF-vie0" //clé des clients
Vue.use(VueGoogleMaps, {
  load: {
    key: googleMapsKey_PROD,
    libraries: "places"
  }
});

// Sentry
if (['preproduction', 'production'].includes(process.env.NODE_ENV)) {
  Sentry.init({
    Vue,
    tunnel: `${process.env.SERVER_URL}/sentry/tunnel`,
    dsn: 'https://075617cb2b04c22851064e17c31d0f92@o493491.ingest.us.sentry.io/4507049700687872',
    environment: process.env.NODE_ENV,
    tracesSampleRate: 1,
    attachProps: true,
    beforeBreadcrumb(breadcrumb, hint) {
      if ((breadcrumb.category === 'console' || breadcrumb.category === "sentry.event") && breadcrumb.message && (breadcrumb.message.includes('[Vue warn]') || breadcrumb.message.includes('[vue-i18n]' || breadcrumb.message.includes('NavigationDuplicated')))) {
        return null;
      }
      if (breadcrumb.category === 'xhr' && breadcrumb.data && breadcrumb.data.status_code >= 400) {
        const dataString = JSON.stringify(breadcrumb.data, null, 2);
        Sentry.captureMessage(`XHR request failed with status ${breadcrumb.data.status_code} => ${dataString} at ${new Date().toISOString()}`, 'error');
      }
      return breadcrumb;
    },
    beforeSend: event => {
      if (event && event.exception && event.exception.values[0].type === "NavigationDuplicated") {
        return
      }
      if (event.message && (event.message.startsWith(`XHR request failed with status`) || event.message.startsWith("feedback"))) {
        localStorage.setItem('lastEventId', event.event_id)
      } else {
        localStorage.setItem('lastEventId', null)
      }
      return event;
    },
    transportOptions: {
      fetchParameters: {
        headers: {
          'Authorization': 'Bearer ' + TokenService.getLocalAccessToken(),
          'Content-Type': 'application/json'
        },
        referrerPolicy: 'strict-origin-when-cross-origin'
      }
    }
  })

  Sentry.configureScope(scope => {
    scope.setTag('lamp_frontend', 'client-public')
    scope.setTag('lamp_frontend_name', 'Lamp - Grand public')
  })
}


/**
 * ---- utiliser le bus dans des components:
 * import {eventBus} from "./main"
 * eventBus.$emit("eventName", param1) => à tout moment (ex avec param)
 * eventBus.$on('eventName', this.function) => dans le created() du component
 * function (param1Name) {...}
 * eventBus.$off('eventName', this.function) => dans le destroyed() du component (important!)
 */
export const eventBus = new Vue()

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  i18n,
  metaInfo: {
    meta: [
      {
        name: 'robots',
        content: window.location.hostname !== 'lamp-app.fr' ? 'noindex, nofollow, noarchive, nosnippet' : 'index, follow'
      }
    ]
  },
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js